module.exports = {"confirm_delete":"Confirm Delete","create":"Create","save":"Save","update":"Update","commit":"Commit","export":"Export"};